import React from "react";
import Layout from "../../../components/layout/layout.js";
import { AddPage } from "../../../components/stats/add-page.js";

export default function StatsAddPage({ component, ...rest }) {
  return <Layout Component={AddPage} {...rest} controlsDisabled />;
}
